/**
 * @voltxampere/ui — Stepper motor 28BYJ-48 variant (Sprint 44-7, placeholder)
 *
 * PLACEHOLDER. 5-pin unipolar 4-phase stepper motor — mevcut
 * `inductor` stamp üzerinden tek phase coil gösterir. Gerçek
 * 4-phase sequencing (full-step / half-step / micro-step) + reduktör
 * (1:64) + per-step 5.625° rotation Sprint 47+ engine extension #4
 * ile (multi-coil composition + sequential state).
 *
 * Reference: Kiatronics 28BYJ-48 — 5 V DC unipolar stepper, 1:64
 * gear reduction, 64 steps/rev × 64 = 4096 micro-steps/rev. Coil
 * R = 50 Ω, L = ~50 mH per phase. Hobbyist + 3D printer extruder
 * + small CNC + Arduino "merhaba dünya" stepper.
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType (single phase coil placeholder).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const motorStepper28byj48 = {
    id: "motor-stepper-28byj48",
    nameTr: "Stepper 28BYJ-48 (5V, 4-phase, placeholder)",
    nameEn: "Stepper 28BYJ-48 (5V, 4-phase, placeholder)",
    shortcut: "L",
    category: "active",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "M",
    defaultValue: "28BYJ-48",
    schemaType: "inductor",
    defaultParams: { inductance: 50e-3 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=motor-stepper-28byj48.js.map